import { render } from "./BearingHeader.vue?vue&type=template&id=4fcea218&scoped=true&lang=pug"
import script from "./BearingHeader.vue?vue&type=script&lang=ts"
export * from "./BearingHeader.vue?vue&type=script&lang=ts"

import "./BearingHeader.vue?vue&type=style&index=0&id=4fcea218&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fcea218"

export default script